import React from "react";
import EventIcons from "../LiveTicker/EventIcons";
import Shirt from "../../../svgs/Shirt";

const BADGE_COLORS = {
    ETW: "#d3d3d3",
    Z: "rgb(204, 224, 231)",
    A: "rgb(255, 167, 167)",
};

/**
 * Renders a match status flag as a visual element.
 * Used by RecapLegend, PlayerRecapTable and RecapList.
 * @param {string} flag
 * @param {{ postText?: string, className?: string }} [s2Options] - extra options for S2 shirt rendering
 */
export function renderMatchStatus(flag, s2Options = {}, icon = true) {
    if (!flag) return "";

    switch (flag) {
        case "X":
            return (
                <EventIcons
                    background=""
                    backgroundImage="none"
                    icon="x"
                    marginRight={0}
                    borderRadius={3}
                    height={25}
                    fontWeight="bold"
                />
            );
        case "R":
            return (
                <EventIcons
                    background="red"
                    backgroundImage="none"
                    icon={icon ? "x" : ""}
                    marginRight={0}
                    borderRadius={3}
                    height={25}
                    fontWeight="bold"
                />
            );
        case "Y":
            return (
                <EventIcons
                    background="yellow"
                    backgroundImage="none"
                    icon={icon ? "x" : ""}
                    marginRight={0}
                    borderRadius={3}
                    height={25}
                    fontWeight="bold"
                />
            );
        case "G":
            return (
                <EventIcons
                    background="green"
                    backgroundImage="none"
                    icon={icon ? "x" : ""}
                    marginRight={0}
                    borderRadius={3}
                    height={25}
                    fontWeight="bold"
                />
            );
        case "YR": {
            const gradient =
                "linear-gradient(to top left, red 50%, yellow 50%)";
            return (
                <EventIcons
                    background={gradient}
                    backgroundImage={gradient}
                    icon={icon ? "x" : ""}
                    marginRight={0}
                    borderRadius={3}
                    height={25}
                    fontWeight="bold"
                />
            );
        }
        case "ETW":
        case "Z":
        case "A":
            return (
                <span
                    style={{
                        display: "inline-block",
                        background: BADGE_COLORS[flag],
                        borderRadius: 4,
                        padding: "2px 6px",
                        fontSize: 12,
                    }}
                >
                    {flag}
                </span>
            );

        case "P":
            return (
                <span
                    style={{
                        display: "inline-block",
                        background: BADGE_COLORS[flag],
                        borderRadius: 4,
                        padding: "2px 6px",
                        fontSize: 12,
                    }}
                >
                    #
                </span>
            );
        case "S":
            return <Shirt fill="black" />;
        case "S1":
            return <Shirt fill="#AAB7B8" />;
        case "S2":
            return <Shirt fill="white" stroke="black" {...s2Options} />;
        default:
            return flag;
    }
}
